module.exports = __webpack_public_path__ + "img/logo_big.2af38ab6.png";